import Layout from "../../components/layout/layout";
import { IoIosArrowForward } from "react-icons/io"
import { Link } from "react-router-dom";

import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import AdminaccTable from "../../components/tables/adminaccTable";
import CustomSelect from "../../components/utils/CustomSelect";

function AdminAccountPage() {
  return (
    <Layout id="adminAccount">
      <div className="top-bar">
        <h2>Compte admin</h2>
        <div className="pagination">
          <Link to="/" className="link">Accueil</Link>
          <IoIosArrowForward color="#A7A7A7" />
          <Link to="#" className="link">Experts</Link>
        </div>
      </div>
      
      <div className="filter-bar">
        <button className="nouveau">
            <span className="plus">+</span>
            <span className="text">Nouveau</span>
        </button>
        <div className="recherche">
          <input type="text" placeholder="Rechercher"/>
          <CustomSelect 
            options={[
              {value: null, label: "Type"},
              {value: 1, label: "1"},
              {value: 2, label: "2"}
            ]}
          />
        </div>
      </div>

      <AdminaccTable />
    </Layout>
  );
}

export default AdminAccountPage;